import axios from 'axios';

export const getUploadErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    if (error.code === 'ECONNABORTED') {
      return 'Upload timed out. Try a smaller file or check your connection.';
    }
    if (!error.response) {
      return "Couldn't reach the server. Please check your connection and try again.";
    }
    const status = error.response.status;
    const rawMessage =
      typeof error.response.data === 'object' && error.response.data !== null
        ? (error.response.data as { message?: unknown }).message
        : undefined;
    const serverMessage = typeof rawMessage === 'string' ? rawMessage : undefined;
    if (status === 413) return 'File is too large to upload. Please choose a smaller file.';
    if (status === 415) return 'That file type is not supported.';
    if (status === 401 || status === 403) return "You don't have permission to upload files here.";
    if (status === 400)
      return serverMessage ?? 'The file was rejected. Please check the file and try again.';
    if (status >= 500) return 'The server had trouble saving the file. Please try again shortly.';
    if (serverMessage) return serverMessage;
  }
  return 'Upload failed. Please try again.';
};
